<template>
    <div>
        <div class="row row-item">
            <div class="col-xs-24">
                <svg-item size="24" :icon="'star'"  :color="'--text-color'" aria-label="Fecha"></svg-item>
                {{ item.promocion ? item.promocion.discount : '' }} % - {{ item.promocion ? item.promocion.anunciante.name : '' }}
            </div>
        </div>
        <div class="row row-item">
            <div class="col-xs-12">
                <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" aria-label="Fecha"></svg-item>
                {{ [ item.created_at  ] | moment("DD/MM/YYYY") }}
            </div>
            <div class="col-xs-12">
                <svg-item size="24" :icon="'time'"  :color="'--text-color'" aria-label="Hora">></svg-item>
                {{ [ item.created_at  ] | moment("HH:mm") }}
            </div>
        </div>
        <div class="row row-item" v-if="item.viaje">
            <div class="col-xs-12">
                <svg-item size="24" :icon="'gps'"  :color="'--text-color'"  aria-label="Origen">></svg-item>
                {{ item.viaje.calle }} {{ item.viaje.altura >= 0 ? item.viaje.altura : '' }}
            </div>
            <div class="row" v-if="item.viaje.dest_nombre">
                <div class="col-xs-24">
                    <svg-item size="24" :icon="'lugar'"  :color="'--text-color'"  aria-label="Destino">></svg-item>
                    {{ item.viaje.dest_nombre }}
                </div>
            </div>
        </div>
        <div class="row row-item">
            <div class="col-xs-24">
                <strong>{{ translateEstado(item.estado) }}</strong>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PromotionItem',
    props: ['item'],
    methods: {
        translateEstado (estado) {
            if (estado === 'utilizada') {
                return this.translate('estadoUtilizada');
            }
            if (estado === 'vencida') {
                return this.translate('estadoVencida');
            }
            return estado;
        }
    }
};
</script>
<style scoped>
    .row-item {
        margin-top: .8em;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/PromotionItem.vue